import { camelCase } from 'lodash';

// TODO: Document it
export const itemWithKeys = (item, whitelistKeys) => {
  if(!item) {
    return {};
  }
  const filtered = Object.keys(item)
  .filter(key => whitelistKeys.includes(key))
  .reduce((obj, key) => {
    return {
      ...obj,
      [key]: item[key]
    };
  }, {});
  return filtered;
}

export const snakeCase = string => {
  return string.replace(/\W+/g, " ")
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('_');
};

export const camelizeKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(v => camelizeKeys(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => {
        let newKey = camelCase(key);
        newKey = newKey.replace("2X", "2x");
        newKey = newKey.replace("3X", "3x");
        return {
          ...result,
          [newKey]: camelizeKeys(obj[key]),
        }
      },
      {},
    );
  }
  return obj;
};